import './style.css'
import * as THREE from 'three'
import * as dat from 'lil-gui'
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader.js';
import { STLExporter } from 'three/examples/jsm/exporters/STLExporter.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

//Initialize the STLExporter library
var stlExporter = new STLExporter();

//Initialize the STLLoader library
var stlLoader = new STLLoader();

// Initialize Three.js scene
var scene = new THREE.Scene();
scene.background = new THREE.Color(0xD3D3D3);

// Create a grid helper
var gridHelper = new THREE.GridHelper(20, 20, 0x0000ff, 0x808080);

// Add the grid helper to the scene
scene.add(gridHelper);

// Create a sphere
var sphereGeometry = new THREE.SphereGeometry(1, 4, 4);
var sphereMaterial = new THREE.MeshPhongMaterial({ color: 0x90EE90, flatShading: true });
var sphere = new THREE.Mesh(sphereGeometry, sphereMaterial);

// Creates lights
const pointLight = new THREE.PointLight(0xffffff, 5, 100);
pointLight.position.set(50, 50, 50);
scene.add(pointLight);


// Add the sphere to the scene
scene.add(sphere);

// Create a camera
var camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
camera.position.set(2.5, 2.5, 5); // move the camera above the sphere
camera.lookAt(sphere.position); // point the camera at the sphere
camera.rotation.x = -Math.PI / 4; // rotate the camera 45 degrees down


// Create a renderer
var renderer = new THREE.WebGLRenderer();
renderer.setSize(window.innerWidth, window.innerHeight);
document.body.appendChild(renderer.domElement);

var orbitControls = new OrbitControls(camera, renderer.domElement);

var scaleControls = { scale: 1 };



// Create a GUI to control the sphere's rotation and segments
var gui = new dat.GUI();
var rotationControls = { x: 0, y: 0, z: 0 };
var segmentControls = { segments: 4 };
gui.add(rotationControls, 'x', 0, 360);
gui.add(rotationControls, 'y', 0, 360);
gui.add(rotationControls, 'z', 0, 360);
gui.add(scaleControls, 'scale', 0.5, 2).step(0.1).onChange(function () {
    sphere.scale.set(scaleControls.scale, scaleControls.scale, scaleControls.scale);
});
gui.add(segmentControls, 'segments', 4, 12).step(1).onChange(function () {
    sphereGeometry = new THREE.SphereGeometry(1, segmentControls.segments, segmentControls.segments);
    sphere.geometry = sphereGeometry;
});
gui.add({
    export: function () {
        var stlString = stlExporter.parse(sphere);
        var blob = new Blob([stlString], { type: 'application/sla' });
        var link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = "sphere.stl";
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}, 'export').name('Export STL');

//Window Resize Handler
window.addEventListener('resize', onWindowResize, false);

function onWindowResize() {

    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();

    renderer.setSize(window.innerWidth, window.innerHeight);

}

// Animate the scene
function animate() {
    requestAnimationFrame(animate);
    sphere.rotation.x = rotationControls.x * Math.PI / 180;
    sphere.rotation.y = rotationControls.y * Math.PI / 180;
    sphere.rotation.z = rotationControls.z * Math.PI / 180;
    orbitControls.update();
    renderer.render(scene, camera);
}
animate();
